import React from "react";
import { Route, Routes, Link, NavLink, useParams } from "react-router-dom";
import MailBotList from "./MailBotList";
import MailBotDetailsDev from "./MailBotDetailsDev";
import NavLeft from "./NavLeft";
import { ExportOutlined } from "@ant-design/icons";

const MailBotDetailsDevWithParams = () => {
  const { id } = useParams();
  return <MailBotDetailsDev id={id} />;
};

const DevPortal = props => (
  <div style={{ maxWidth: 1000, marginLeft: "auto", marginRight: "auto" }}>
    <div className="col-sm-2 subnav">
      <NavLeft>
        <li>
          <NavLink to="/developer" end>
            My Skills
          </NavLink>
        </li>
        <li>
          <NavLink to="/developer/create">New Skill</NavLink>
        </li>
        <li>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://fut.readme.io/"
          >
            Docs <ExportOutlined />
          </a>
        </li>
      </NavLeft>
    </div>
    <div className="col-sm-8">
      <Routes>
        <Route
          path="create"
          element={<MailBotDetailsDev />}
        />

        <Route
          path="skills/:id/*"
          element={<MailBotDetailsDevWithParams />}
        />
        <Route
          path="/"
          element={
            <div>
              <h1
                style={{ fontFamily: "Lora", marginTop: 20, marginBottom: 5 }}
              >
                My Skills
              </h1>
              <MailBotList owner="self" loggedInUser={props.loggedInUser} />
            </div>
          }
        />
      </Routes>
    </div>
  </div>
);

export default DevPortal;
